import { Text } from '@modusign/design-system';

export default function AddressBookFeatureDescription() {
  return (
    <Text
      as="p"
      color="textNeutralSlightlyLight"
      fontSize="lg"
      mb={9}
      mt={7}
      pb={1}
      textAlign="center"
    >
      자주 서명 요청하는 연락처를 추가해 보세요.
      <br />
      주소록 검색으로 연락처를 자동 입력할 수 있습니다.
    </Text>
  );
}
